import { WarehouseModelType } from '@teinor/erp/types/company/warehouse'
import { MediumModalCreateEdit } from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import { getDictionaryStates } from '../../../../../../utils/globals/countries'
import useCountryState from '../../../../../../utils/hooks/useCountry'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getDictionaryCountries } from '../../../../../../utils/reducers/getters'
import { sortCountries } from '../../../../../../utils/globals/sortCountries'

interface ModalCreateWarehouseProps extends ModalEditComponentProps{}

const ModalCreateWarehouse: React.FC<ModalCreateWarehouseProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const { country, setCountry } = useCountryState({defaultCountry: allRowData?.country })
    const fields: FormRender<WarehouseModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'code',
                    label: t('code', 'Código'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'sales_representative',
                    label: t('salesRepresentative', 'Ventas a representante'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'stock_valid',
                    label: t('stocksValid', 'Validar Stock'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'not_inventories',
                    label: t('notInventories', 'Sin inventarios'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'blocked_inventory',
                    label: t('blockedInventory', 'Inventario bloqueado'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ],
        },
        {
            cols: 2,
            title: t('address', 'Dirección'),
            elements: [
                {
                    name: 'address',
                    label: t('address', 'Dirección'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'additional_address',
                    label: t('number', 'Número'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'postal_code',
                    label: t('postal_code', 'Código Postal'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'city',
                    label: t('city', 'Ciudad'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'country',
                    label: t('country', 'País'),
                    component: 'CustomSelectWithSearchBar',
                    items: getDictionaryCountries(),
                    sortFunction: sortCountries,
                    onChange: (value: string) => setCountry(value),
                    required: true
                },
                {
                    name: 'state',
                    label: t('state', 'Provincia'),
                    component: 'CustomSelectWithSearchBar',
                    sortItems: true,
                    items: getDictionaryStates(country),
                }
            ]
        },
    ]
    return (<MediumModalCreateEdit fields={fields} url={'/api/app/warehouse/createWarehouse'} translations={{
        title: t('createWarehouse', 'Crear almacén'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}


export default ModalCreateWarehouse;